const UPDATE_FOUND = `
업데이트가 발견되어 새로운 버전을 설치 합니다
`;

const ERROR_OCCURED = `
에러가 발생 했습니다
KLS 사용 시 제약이 있을 수 있습니다
`;

const PERMISSION_DENIED = `
알림 메시지를 허용하지 않았습니다
KLS 사용 시 제약이 있을 수 있습니다
`;

const ALERT_MSG = { UPDATE_FOUND, ERROR_OCCURED, PERMISSION_DENIED };

export const invokeServiceWorkerUpdateFlow = (registration) => {
  registration.waiting.postMessage('SKIP_WAITING');

  if (Notification.permission === 'granted') {
    try {
      registration.showNotification('업데이트 발견', {
        body: '업데이트가 발견되어 새로운 버전을 설치 합니다',
        icon: 'logo_192.png',
        vibrate: [300, 100, 300],
      });
    } catch (error) {
      console.log(error.message);
      alert(ALERT_MSG.UPDATE_FOUND);
    }
  } else {
    alert(ALERT_MSG.UPDATE_FOUND);
  }
};

const addUpdateFoundEventListener = (registration) => {
  registration.addEventListener('updatefound', () => {
    console.log('새로운 업데이트가 발견되었습니다');

    registration.installing.addEventListener('statechange', () => {
      if (!registration.waiting) {
        return;
      }

      if (navigator.serviceWorker.controller) {
        invokeServiceWorkerUpdateFlow(registration);
      } else {
        console.log('서비스 워커 최초 초기화...');
      }
    });
  });
};

export const registerSW = () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('서비스 워커 등록:', registration);

        if (registration.waiting) {
          invokeServiceWorkerUpdateFlow(registration);
        }

        Notification.requestPermission().then((permission) => {
          if (permission === 'denied') {
            alert(ALERT_MSG.PERMISSION_DENIED);
          }
        });

        addUpdateFoundEventListener(registration);
      })
      .catch((registrationError) => {
        console.log('서비스 워커 등록 실패:', registrationError);
      });
    let refreshing = false;

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        window.location = window.location.origin;
        refreshing = true;
      }
    });
  });
};

export const unregister = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log('서비스 워커 등록 취소:', registration);
      })
      .catch((error) => {
        console.log('서비스 워커 등록 취소 실패:', error.message);
      });
  }
};
